import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import './Booking.scss';
import IdentificationForm from '../IdentificationForm';
import BankSelection from '../../components/BankSelection';

const LoginComponent = (props) => {
  const { loginType } = props;
  if (loginType === 'STRONG') {
    return <BankSelection showBackButton={false} />;
  }
  return <IdentificationForm />;
};

LoginComponent.propTypes = {
  loginType: PropTypes.string.isRequired
};

export default translate(props => ['booking', props.pathNamespace], { wait: true })(LoginComponent);



// WEBPACK FOOTER //
// ./src/containers/Booking/LoginComponent.jsx